import { useCallback, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import { Dialog, Text, Button } from '@/ui'
import { useAppDispatch } from '@/utils/typeHelpers'
import { TypographyStyles } from '@/styles'
import { deleteUserIncomePlan } from '@/features/income-planning/incomePlanning.slice'

export const DeletePlanDialog = ({ planId }: { planId: number }) => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const [open, setOpen] = useState(false)

  const deletePlan = useCallback(async () => {
    await dispatch(deleteUserIncomePlan(planId))
    navigate('/income-planning')
  }, [dispatch, navigate, planId])

  return (
    <Dialog open={open} onClose={() => setOpen(false)}>
      <Dialog.Trigger>
        <Button variant="danger" onClick={() => setOpen(true)}>
          Delete
        </Button>
      </Dialog.Trigger>
      <Dialog.Content onDismiss={() => setOpen(false)}>
        <Dialog.Title>Delete Plan</Dialog.Title>
        <Text variant={TypographyStyles.BODY_SM} className="mt-2">
          Once this is deleted, it cannot be undone. The months that this plan
          was applied to will not be affected.
        </Text>
        <Dialog.Footer>
          <Button variant="secondary" onClick={() => setOpen(false)}>
            Cancel
          </Button>
          <Button variant="danger" onClick={deletePlan}>
            Delete
          </Button>
        </Dialog.Footer>
      </Dialog.Content>
    </Dialog>
  )
}
